import { render } from "./DecorativeSeparator.vue?vue&type=template&id=c1cfb104&scoped=true"
import script from "./DecorativeSeparator.vue?vue&type=script&lang=js"
export * from "./DecorativeSeparator.vue?vue&type=script&lang=js"

import "./DecorativeSeparator.vue?vue&type=style&index=0&id=c1cfb104&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1cfb104"]])

export default __exports__